import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import Login from '@/components/LoginNew'
import changePassword from '@/components/ChangePassword'
import Policy from '@/components/Policy'

import Terms from '@/components/Terms'
import Dashboard from '@/components/Dashboard'

import Home from '@/components/Home'

import About from '@/components/Portal/About'

import Download from '@/components/Portal/Download'
import Contact from '@/components/Portal/Contact'

import LoanSignup from '@/components/RegistrationLoan/Signup'
import LoginProfile from '@/components/RegistrationLoan/LoginEditProfile'
import ViewPresonalDetails from '@/components/RegistrationLoan/ViewPresonalDetailsProfile'
import ViewGroupDetails from '@/components/RegistrationLoan/ViewGroupDetailsProfile'
import ViewEducationDetails from '@/components/RegistrationLoan/viewPresDetailDashEducation'
import ViewPersonalprofile from '@/components/RegistrationLoan/viewPresDetailDash'
// import BankDetails from "@/components/RegistrationLoan/BankDetailsFormInvGroup";
import BankDetails from "@/components/RegistrationLoan/BankDetailsForm";
import Eprofile from "@/components/RegistrationLoan/EditProfile";
import LoanLOIPrint from '@/components/RegistrationLoan/LoanLOIPrint';

import AdminDashboard from "@/components/Admin/AdminDashboard";
import Applications from "@/components/Admin/Applications";
import ProfileApproval from "@/components/Admin/ViewPersonalDetailsProfile";
import GroupProfileApproval from "@/components/Admin/ViewGroupDetailsProfile";
import ResetPassword from "@/components/Admin/ChangePassword";
import Reports from "@/components/Admin/misReport"
import ChangeBoard from "@/components/Admin/ChangeBoard"

import AdminReports from "@/components/AdminReports/Report"

import Disbursal from "@/components/LoanDisbursal/DisbursalList"
import AddDisbursal from "@/components/LoanDisbursal/UploadDisbursal"
import SanctionLetter from "@/components/LoanDisbursal/SanctionLetter"

import ClaimUpload from "@/components/ClaimUpload/UploadClaim"
import ClaimList from "@/components/ClaimUpload/ClaimList"
import ClaimListAdmin from "@/components/ClaimUpload/ClaimListAdmin"

import ClaimApproveList from "@/components/ClaimApproval/ClaimList"
import SanctionLetterList from "@/components/ClaimApproval/SanctionLetterList"
import DisbursalList from "@/components/ClaimApproval/DisbursalList"

import VerifyLOI from "@/components/RegistrationLoan/VerifyLoi"

import DocEdit from "@/components/Admin/DocumentUpload"

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next()
    return
  }
  next('/home')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next()
    return
  }
  next('/')
}

const ifAuthenticatedProfile= (to, from, next) => {
  console.log(store.getters.isLoggedIn);
  if((!store.getters.lockProfile && store.getters.isLoggedIn) || !store.getters.isLoggedIn) {
    next()
    return
  } else {
    alert("Profile is Locked");
    next('/dashboard');
  }
}

const ifAdminAuthenticated = (to, from, next) => {
  var nme = store.getters.loggedUser;
  var RoleID =  nme.RoleID;
  if (store.getters.isLoggedIn && RoleID!=0) {
    next()
    return
  }
  next('/')
}


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/verifyloi/:ApplicationID/:LOINumber',
      name:'VerifyLOI',
      component:VerifyLOI,
      props:true
    },
    {
      path:'/claimupload',
      name: 'ClaimUpload',
      component:ClaimUpload,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/claims',
      name: 'ClaimList',
      component:ClaimList,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/claimsAdmin',
      name: 'ClaimListAdmin',
      component:ClaimListAdmin,
      props:true
    },
    {
      path:'/disbursals',
      name: 'DisbursalList',
      component:DisbursalList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/approveclaims',
      name: 'ClaimApproveList',
      component:ClaimApproveList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/sanctionletters',
      name: 'SanctionLetterList',
      component:SanctionLetterList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/profileapproval',
      name: 'ProfileApproval',
      component:ProfileApproval,
      props:true,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/groupprofileapproval',
      name: 'GroupProfileApproval',
      component:GroupProfileApproval,
      props:true,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/disbursal',
      name: 'Disbursal',
      component:Disbursal,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/newdisbursal',
      name: 'AddDisbursal',
      component: AddDisbursal,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/sanctionletter',
      name: 'SanctionLetter',
      component: SanctionLetter,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/',
      name: 'Home',
      component:Home,
     
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path:'/changePassword',
      name:'changePassword',
      component:changePassword,
      beforeEnter: ifAuthenticated,
    },
    {
      path:'/resetPassword',
      name:'resetPassword',
      component:ResetPassword,
      beforeEnter: ifAdminAuthenticated,
    },
    {
      path:'/reports',
      name:'reports',
      component:Reports,
      beforeEnter: ifAdminAuthenticated,
    },
    {
      path:'/changeboard',
      name:'ChangeBoard',
      component:ChangeBoard,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path: '/ViewPersonalprofile',
      name: 'ViewPersonalprofile',
      component: ViewPersonalprofile,
      beforeEnter: ifAuthenticated
    },
    {
      path:'/Eprofile',
      name:'Eprofile',
      component:Eprofile,
      beforeEnter: ifAuthenticatedProfile
    },

    // {
    //   path: '/aboutus',
    //   name: 'AboutUs',
    //   component: AboutUs
    // },
    {
      path: '/privacy',
      name: 'Policy',
      component: Policy
    },
    {
      path: '/BankDetails',
      name: 'BankDetails',
      component: BankDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/LoanLOIPrint',
      name: 'LoanLOIPrint',
      component: LoanLOIPrint,
      props:true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/DocEdit',
      name: 'DocEdit',
      component:DocEdit,
      props:true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },

    {
      path: '/about',
      name: 'About',
      component: About
    },

    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },

    {
      path: '/ViewPresonalDetails',
      name: 'ViewPresonalDetails',
      component: ViewPresonalDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ViewGroupDetails',
      name: 'ViewGroupDetails',
      component: ViewGroupDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ViewEducationDetails',
      name: 'ViewEducationDetails',
      component: ViewEducationDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated,
    },
 
    {
      path: '/LoanSignup',
      name: 'LoanSignup',
      component: LoanSignup
    },
    {
      path: '/LoginProfile',
      name: 'LoginProfile',
      component: LoginProfile,
      beforeEnter: ifAuthenticatedProfile
    },
    
    {
      path: "/admindashboard",
      name: 'AdminDashboard',
      component: AdminDashboard,
      beforeEnter: ifAdminAuthenticated
    },
    {
      path: "/applications",
      name: 'Applications',
      component: Applications,
      props:true,
      beforeEnter: ifAdminAuthenticated
    },
    {
      path: "/adminreports",
      name: "AdminReports",
      component:AdminReports,
      beforeEnter:ifAdminAuthenticated
    },
    {
      // Catch all 404s and redirect to home page
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js